import React, { useState } from 'react'
import { styled } from '../../../../stitches.config'
import useGetGreetingCardDesigns from '../../../hooks/useGetGreetingCardDesigns'
import { Dialog, DialogClose, DialogContent } from '../../elements/Modals/Modal'
import { SelectInput } from '../../elements/Forms/SelectWithLabel'
import HeadlineEyebrow from '../headlines/HeadlineEyebrow'
import uniq from 'lodash/uniq'
import map from 'lodash/map'
import filter from 'lodash/filter'
import get from 'lodash/get'
import NextImage from '../images/NextImage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark'

const StyledDialogContent = styled(DialogContent, {
    display: 'flex',
    flexDirection: 'column',
    p: '10px 10px 0',
    overflow: 'hidden',
    '@md': {
        p: '40px 40px 0 60px',
        minHeight: '90vh',
    },
})
const ModalHeaderWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: 20,
    '@md': {
        flexDirection: 'row',
    },
})
const IconButton = styled('button', {
    all: 'unset',
    fontFamily: 'inherit',
    borderRadius: '100%',
    height: 25,
    width: 25,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '$dark',
    position: 'absolute',
    top: 10,
    right: 10,
    '&:hover': { backgroundColor: '$light' },
})
const SelectInputWrapper = styled('div', {
    minWidth: '18em',
    pr: 20,
    mt: 20,
    '@md': {
        mt: 0,
    },
})
const ScrollWrapper = styled('div', {
    marginTop: 40,
    overflowY: 'scroll',
    pr: '20px',
})
const DesignsWrapper = styled('div', {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-around',
    gap: 15,
})
const Design = styled('div', {
    display: 'flex',
    maxWidth: '200px',
})

export const ModalContentGreetingCards: React.FC<{
    isOpen: boolean
    setIsOpen: Function
}> = ({ isOpen, setIsOpen }) => {
    const [selectedCategory, setSelectedCategory] = useState('empty')
    const { data, isLoading, isSuccess, isError, error } =
        useGetGreetingCardDesigns()
    const categories = uniq(map(data, 'data.category.value.name'))
    const categorySelectOptions = categories.map((category) => {
        return { label: category, value: category }
    })
    const filteredDesigns = filter(data, (design) => {
        return (
            'empty' === selectedCategory ||
            selectedCategory === get(design, 'data.category.value.name')
        )
    })

    return (
        <Dialog open={isOpen}>
            <StyledDialogContent
                width={'wide'}
                data-testid="greeting_card_designs_modal"
            >
                <ModalHeaderWrapper>
                    <div>
                        <HeadlineEyebrow label={'Greeting card designs'} />
                    </div>
                    <SelectInputWrapper>
                        <SelectInput
                            label={'Category'}
                            emptyOptionLabel={'All'}
                            options={categorySelectOptions}
                            onValueChange={(value: any) => {
                                setSelectedCategory(value)
                            }}
                            css={{ minWidth: '30em' }}
                        />
                    </SelectInputWrapper>
                </ModalHeaderWrapper>
                <ScrollWrapper>
                    <DesignsWrapper>
                        {filteredDesigns.map((design) => (
                            <Design key={design.name}>
                                <NextImage
                                    altText={design.name}
                                    image={design.data?.image}
                                    layout={'intrinsic'}
                                    width={188}
                                    height={291}
                                />
                            </Design>
                        ))}
                    </DesignsWrapper>
                </ScrollWrapper>
                <DialogClose asChild>
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            setIsOpen(false)
                            setSelectedCategory('empty')
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </IconButton>
                </DialogClose>
            </StyledDialogContent>
        </Dialog>
    )
}

export default ModalContentGreetingCards
